import React, { useEffect, useRef, useState } from "react";
import albumPoster from "../assets/album-poster/swing-de-la-calle.jpg";
import { SiApplemusic, SiSpotify, SiYoutube } from "react-icons/si";
import { Link } from "react-router-dom";
import { useScroll, motion } from "framer-motion";
import PlatformList from "./PlatformList";
import Header from "./Header";
import songs from "../constant/swing-de-la-calle.json";

export default function DialogAlbum() {
  const targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start start", "end end"],
  });
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const unsubscribeProgress = scrollYProgress.on("change", (value) => {
      setProgress(value * 2); // Scale the progress for character animation
      console.log(value);
    });

    return () => {
      unsubscribeProgress();
    };
  }, [scrollYProgress]);

  return (
    <div ref={targetRef} className="w-full h-[280vh]">
      <div className="sticky top-0 z-0">
        <Header />
      </div>
      <motion.div className={`w-full h-[100vh] inset-0 relative bg-black bg-opacity-90 flex justify-center items-center z-50 gap-12 sticky top-0 flex-col md:flex-row overflow-hidden ${progress < 0.19 ? "pointer-events-none" : ""}`}
      initial={{
        opacity: 0,
      }}
      animate={
        progress > 0.19
          ? {
              opacity: 1,
            }
          : { opacity: progress }
      }
      transition={{
        duration: 0.3,
      }}

      >
        <div className="w-full px-12 md:px-0 md:w-[30%]">
          <motion.img
            src={albumPoster}
            alt="Swing de la calle"
            className="w-full h-full object-cover"
            initial={{
              opacity: 0,
              x: -60,
              scale: 0.8,
            }}
            animate={
              progress > 0
                ? {
                    opacity: 1,
                    x: 0,
                    scale: 1,
                  }
                : {}
            }
            transition={{
              duration: 0.3,
            }}
          />
        </div>
        <motion.div
          initial={{
            opacity: 0,
            x: 60,
            scale: 0.8,
          }}
          animate={
            progress > 0.19
              ? {
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }
              : {}
          }
          transition={{
            duration: 0.3,
          }}
          className="flex flex-col text-white gap-4 w-full md:w-[30%] justify-center items-center px-6 md:px-0"
        >
          {/* <h2 className="text-5xl font-bold">Swing de la calle</h2> */}
          <div className="flex flex-col mt-0 md:mt-10 justify-center items-center w-full">
            {songs.map((song, index) => (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 30,
                }}
                animate={
                  progress > 0.19
                    ? {
                        opacity: 1,
                        y: 0,
                      }
                    : {}
                }
                transition={{
                  duration: 0.3,
                  //   ease: "easeInOut",
                  delay: index * 0.1,
                }}
                key={song.title}
                className={`w-full flex justify-between items-center rounded-2xl px-5 py-3 transition-all duration-300 ${
                  ((progress / 2) * 5).toFixed(0) == song.id
                    ? "bg-white text-black"
                    : ""
                }`}
              >
                <div className="flex gap-6 items-center justify-center">
                  <p
                    className={`text-xs md:text-md font-light transition-all duration-300 text-[#999]`}
                  >
                    {song.id}
                  </p>
                  <div className="flex flex-col">
                    <p
                      className={`text-sm md:text-lg font-medium transition-all duration-300`}
                    >
                      {song.title}
                    </p>
                    <p
                      className={`text-xs md:text-md font-light transition-all duration-300 text-[#999]`}
                    >
                      {song.artist}
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <p
                    className={`text-xs md:text-lg font-light transition-all duration-300`}
                  >
                    {song.duration}
                  </p>
                  <PlatformList
                    links={[
                      {
                        platformName: "Spotify",
                        platformIcon: (
                          <SiSpotify className="text-[#1db954]" size="24px" />
                        ),
                        url: song.spotify,
                      },
                      {
                        platformName: "Apple Music",
                        platformIcon: (
                          <SiApplemusic
                            className="text-[#fc3c44]"
                            size="24px"
                          />
                        ),
                        url: song.appleMusic,
                      },
                    ]}
                  />
                </div>
              </motion.div>
            ))}
          </div>
          <div className="flex gap-4 items-center justify-between w-full">
            <p className="text-md font-light transition-all duration-300 text-white">
              Escuchar album completo en:
            </p>
            <div className="flex items-center bg-white rounded-2xl px-5 py-3">
              <PlatformList
                links={[
                  {
                    platformName: "Spotify",
                    platformIcon: (
                      <SiSpotify className="text-[#1db954]" size="24px" />
                    ),
                    url: "https://open.spotify.com/album/1G9YgYhvdsnElfaLDMQ0DP?si=QsfFV0YkRJKGjPyUTw4q4Q",
                  },
                  {
                    platformName: "Apple Music",
                    platformIcon: (
                      <SiApplemusic className="text-[#fc3c44]" size="24px" />
                    ),
                    url: "https://music.apple.com/co/album/swing-de-la-calle-ep/1810934459",
                  },
                ]}
              />
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}

